import PriceChangesGlobalOrgNotice from '@/components/products/price-changes/PriceChangesGlobalOrgNotice'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import ProductPriceAdjustmentForm from '@/components/forms/ProductPriceAdjustmentForm'
import useIsGlobalOrg from '@/hooks/useIsGlobalOrg'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { collectionQueries } from '@/lib/services/collections/collections.query'
import {
  priceAdjustmentQueries,
  supportsPriceAdjustmentsForOrganizationId,
  usePriceAdjustment,
} from '@/lib/services/price-adjustments/priceAdjustments.query'
import { priceAdjustmentSchema } from '@/lib/services/price-adjustments/priceAdjustments.schema'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Tags } from 'lucide-react'

export const Route = createFileRoute(
  '/_authenticated/$orgId/products/price-changes/$priceAdjustmentId'
)({
  component: PriceChangeDetailRouteComponent,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => priceAdjustmentSchema.parse(params),
  },
  loader: async ({ context, params }) => {
    if (!context.ability.can('edit', 'products')) throw notFound()

    let priceAdjustment = null

    if (supportsPriceAdjustmentsForOrganizationId(params.orgId)) {
      priceAdjustment = await context.queryClient.ensureQueryData(
        priceAdjustmentQueries.show({
          organizationId: params.orgId,
          priceAdjustmentId: params.priceAdjustmentId,
        })
      )
      void context.queryClient.ensureQueryData(
        collectionQueries.index({ organizationId: params.orgId, filters: {} })
      )
    }

    return { priceAdjustment, isReadOnly: false }
  },
})

export function PriceChangeDetailRouteComponent() {
  const isGlobalOrg = useIsGlobalOrg()

  if (isGlobalOrg) {
    return <PriceChangesGlobalOrgNotice />
  }

  return <PriceChangeDetailPage />
}

export function PriceChangeDetailPage() {
  const { priceAdjustmentId } = Route.useParams()
  const { data: priceAdjustment } = usePriceAdjustment(priceAdjustmentId)

  return (
    <div className="space-y-4">
      <AdminPageHeader icon={Tags} title="Price Change" />
      <ProductPriceAdjustmentForm initialData={priceAdjustment} showPageTreatment />
    </div>
  )
}
